import React from 'react';
import { useParams } from 'react-router-dom';
import QuizContainer from '../components/QuizContainer';
import { quiz } from '../components/HTMLQuiz';

const HTMLQuiz = () => {
const { id } = useParams();
  
  return (
    <QuizContainer 
      quizData={quiz}
      courseId={id}
    />
  );
};

export default HTMLQuiz;